import { IonButton } from "@ionic/react";

interface TextButtonProps {
  text?: string;
  expand?: "block" | "full";
  mode?: "md" | "ios";
  shape?: "round";
  className?: string;
  onClick: () => void;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const TextButton = ({
  text,
  expand = "block",
  mode,
  shape,
  className,
  onClick,
  children,
  style,
}: TextButtonProps) => {
  return (
    <IonButton
      onClick={onClick}
      mode={mode}
      fill="clear"
      color="dark"
      shape={shape}
      expand={expand}
      className={className}
      style={{ textTransform: "none", ...style }}
    >
      {text ? text : children}
    </IonButton>
  );
};
